import React from 'react';
import { MODAL_BUTTONS_CLASS } from './Modal.js';

import './ModalButtons.scss';

export const ModalButtons = ({ children }: React.PropsWithChildren) => (
  <div className={MODAL_BUTTONS_CLASS}>{children}</div>
);
